import { useIsUngatedFor } from 'voice-sms-access-library/access/hooks/useIsUngatedFor';
import { gate } from 'hub-http/gates';
export const RECORDINGS_IN_FILE_MANAGER = gate('Calling:Extensions:AppAuthProxyRecordingUrl');
export const useIsUngatedForRecordingsInFileManager = () => {
  return useIsUngatedFor(RECORDINGS_IN_FILE_MANAGER);
};